import { render, staticRenderFns } from "./ContactCards.vue?vue&type=template&id=257a941a&scoped=true"
import script from "./ContactCards.vue?vue&type=script&lang=js"
export * from "./ContactCards.vue?vue&type=script&lang=js"
import style0 from "./ContactCards.vue?vue&type=style&index=0&id=257a941a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257a941a",
  null
  
)

export default component.exports